import { useCallback } from 'react';

import { loadWhiteboardStore } from '../../components/whiteboard/loadAppWhiteboardStore';
import type { DataChannelMessageSender, DataChannelWhiteboardSnapshotMessage } from '../../video-sdk';
import { DataChannelMessageType, useSendMessage } from '../../video-sdk';

export const useSendWhiteboardSnapshotCallback = () => {
  const sendMessage = useSendMessage();
  return useCallback(
    async (senderIdentity: DataChannelMessageSender) => {
      const store = await loadWhiteboardStore();
      const formattedMessage: DataChannelWhiteboardSnapshotMessage = {
        snapshot: store.getStoreSnapshot(),
        type: DataChannelMessageType.WHITEBOARD_SNAPSHOT,
        sender: senderIdentity,
      };

      await sendMessage(formattedMessage);
    },
    [sendMessage],
  );
};
